export default __webpack_public_path__ + "static/media/555.d4bd7dd7.png";